import { noop } from "../../_util/noop";
export var useReady = noop;
export var nextTick = noop;
export var pxTransform = noop;
export var getSystemInfoSync = noop;
var Taro = { useReady: useReady, nextTick: nextTick, pxTransform: pxTransform, getSystemInfoSync: getSystemInfoSync };
export default Taro;
//# sourceMappingURL=index.js.map